import { Injectable, inject, signal } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

export type Lang = 'pt' | 'en' | 'es';

const SUPPORTED: Lang[] = ['pt', 'en', 'es'];
const STORAGE_KEY = 'cm-lang';

@Injectable({ providedIn: 'root' })
export class LanguageService {
  private translate = inject(TranslateService);
  private document = inject(DOCUMENT);

  readonly supported = SUPPORTED;
  readonly current = signal<Lang>('pt');

  init() {
    this.translate.addLangs(SUPPORTED);
    this.translate.setDefaultLang('pt');
    this.use(this.resolveInitialLang());
  }

  use(lang: Lang) {
    const target = SUPPORTED.includes(lang) ? lang : 'pt';
    this.translate.use(target);
    this.current.set(target);
    this.document.documentElement.lang = target;
    try {
      localStorage.setItem(STORAGE_KEY, target);
    } catch {
      // localStorage indisponível (SSR/modo privado): ignora persistência
    }
  }

  private resolveInitialLang(): Lang {
    // Padrão sempre PT; respeita apenas a escolha anterior do usuário.
    let stored: string | null = null;
    try {
      stored = localStorage.getItem(STORAGE_KEY);
    } catch {
      stored = null;
    }
    if (stored && SUPPORTED.includes(stored as Lang)) {
      return stored as Lang;
    }
    return 'pt';
  }
}
